import { formatMessage } from "i18n/CurrentLocale"
import { Fragment, useEffect, useState } from "react";
import { DropdownOption } from "screens/modals/ChooseConnectionModal";
import { TelematicProviderName } from "types";
import Select from 'react-select';
import placeholders from "string-translations/placeholders";
import { Api } from 'api';


type Props = {
    telematicProvider?: string | null,
    onChange: Function
}

export const TelematicProvidersDropdown = (props: Props) => {
    const [telematicProviderOptions, setTelematicProviderOptions] = useState<DropdownOption[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const list = await Api.getAllTelematicProviderNames() ?? [];

                const options: DropdownOption[] = [
                    {
                        value: 'APP',
                        label: formatMessage({ id: 'TELEMATIC_PROVIDER_DROPDOWN_OPTION_NO_TRACK_AND_TRACE' })
                    },
                    ...list
                        .filter(t => t.providerType !== 'APP')
                        .sort((a, b) => a.displayName.localeCompare(b.displayName))
                        .map((t: TelematicProviderName) => ({
                            value: t.providerType,
                            label: t.displayName
                        })),
                    {
                        value: 'OTHER',
                        label: formatMessage({ id: 'TELEMATIC_PROVIDER_DROPDOWN_OPTION_OTHER' })
                    },
                ];
                setTelematicProviderOptions(options);
            } catch (e) {
                console.error('FAAAAILS')
                console.error(e); // what todo if call fails?
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return (
        <Fragment>
            <Select
                inputId="telematic-provider-dropdown"
                name="telematicProvider"
                value={telematicProviderOptions
                    .filter(({ value }) => value === props.telematicProvider)
                } // V2 - simpleValue
                placeholder={formatMessage(placeholders.choose)}
                onChange={(option: any) => props.onChange(option)}
                options={telematicProviderOptions}
                isLoading={loading}
                isSearchable={false}
                className={`react-select-container react-select-with-border ${props.telematicProvider ? 'valid' : 'error'}`}
                classNamePrefix={'react-select'}
            />
        </Fragment>
    )
}

export default TelematicProvidersDropdown;